import React from 'react'
const SettingsPage: React.FC = () => (
  <div className="space-y-6">
    <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
    <div className="card"><div className="card-body text-center py-12"><p className="text-gray-600">Settings and configuration coming soon...</p></div></div>
  </div>
)
export default SettingsPage